import { InfoCircleFilled } from '@ant-design/icons';
import AdConfigModel from '@mm/state/model/AdConfigModel';
import WidgetModel from '@mm/state/model/WidgetModel';
import { selectMessengerAds } from '@mm/state/selectors/adConfigSelectors';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import useRouter from 'use-react-router';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import {
  PathGraphContext,
  useNewGraphInstance,
} from '../../../../../../common/widgets/common/PathGraph/PathGraph';
import { useShowInactiveBannerFlag } from '../../../../../common/hooks/use-show-inactive-bot-banner-flag';
import { StartBotsDialogueEditor } from '../../../../startBotPromoters/common/StartBotsDialogueEditor/StartBotsDialogueEditor';
import { MESSAGE_TEXT, PUBLISH_AD } from '../../../constants/constants';
import { onClickActivate } from '../../../utils/utils';

type Props = {
  adConfig: AdConfigModel | null;
  valid: boolean;
  botId: number;
  pageWidgets: WidgetModel[];
};

export const StartBotStep = (props: Props) => {
  const { adConfig, botId, pageWidgets, valid } = props;

  const activeBot = useSelector(activeChatbotSelector);
  const dispatch: Dispatch<StoreState> = useDispatch();
  const { history } = useRouter();
  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  const messengerAds = useSelector(selectMessengerAds).filter(a => !a.draft);
  const pro = !!featureFlags.adsOneNewCtmAd;
  const armLandmine =
    !pro ||
    (!featureFlags.adsUnlimitedNewCtmAds && (messengerAds?.length || 0) > 1);

  const draft = !adConfig || adConfig.draft;

  const pathGraph = useNewGraphInstance(
    adConfig?.replacementPageId || adConfig?.pageId,
  );
  const { activateChatbotWithCallback } = useShowInactiveBannerFlag();
  const onClick = () =>
    activateChatbotWithCallback(() =>
      onClickActivate(dispatch, history, adConfig, botId, armLandmine, pro),
    );

  return (
    <>
      <div>
        <div className="ad-detail__subtext">
          <InfoCircleFilled className="ad-detail__info-circle" />
          <div>{MESSAGE_TEXT}</div>
        </div>
      </div>
      {adConfig && (
        <PathGraphContext.Provider value={pathGraph}>
          <StartBotsDialogueEditor
            chatbotId={botId}
            forAds={true}
            isDisabled={adConfig?.publishingProcess}
            widgets={pageWidgets}
            hideTopWidgetAdder={true}
            disableFirstWidgetDeleting={true}
            dialogueId={adConfig.replacementPageId || adConfig.pageId}
            restrictToChannels={['facebook']}
            platforms={['facebook']}
            showOnlyNameAttributes
          />
        </PathGraphContext.Provider>
      )}
      {draft && (
        <PrimaryButton
          className="ad-detail__activate-button"
          onClick={onClick}
          disabled={
            !adConfig ||
            adConfig.publishingProcess ||
            !valid ||
            activeBot.template
          }
          color={ButtonColor.blue}
        >
          {PUBLISH_AD}
        </PrimaryButton>
      )}
    </>
  );
};
